"use client";
import React, { startTransition, useState } from "react";
import SA from "@/public/images/SA_flag.svg";
import EN from "@/public/images/English.svg";
import check from "@/public/images/Check.svg";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components-shared/ui/popover";
import Image from "next/image";
import { useLocale } from "next-intl";
import { setUserLocale } from "@/src/services/locale";
import { Locale, locales } from "@/src/i18n/config";

function LanguageSwitch({ className }: { className?: string }) {
  const locale = useLocale();
  const [open, setOpen] = useState(false);

  const handleChangeLang: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    const nextLocale = e.currentTarget.value as Locale;
    startTransition(() => {
      setUserLocale(nextLocale);
    });
  };

  return (
    <Popover {...{ open, onOpenChange: setOpen }}>
      <PopoverTrigger className={className}>
        <Image src={locale == "ar" ? SA : EN} className="!size-9" alt="flag" />
      </PopoverTrigger>
      <PopoverContent className="w-[150px] px-0">
        <>
          {locales.map((l) => {
            return (
              <button
                onClick={handleChangeLang}
                type="button"
                className="w-full"
                value={l}
                key={l}
              >
                <div className="flex justify-between px-4 mb-3">
                  <p
                    className={
                      " capitalize text-[14px] " +
                      (locale == l ? " text-[#00AE41]" : "")
                    }
                  >
                    {l == "en" ? "English" : "العربية"}
                  </p>
                  {locale == l && (
                    <Image src={check} className="size-5" alt="flag" />
                  )}
                </div>
              </button>
            );
          })}
        </>
      </PopoverContent>
    </Popover>
  );
}

export default LanguageSwitch;
